import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { processingFeesServiceConfigSchema } from '../configurations/ProcessingFeesServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderProcessingFeesDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.PROCESSING_FEES]: processingFeesServiceConfigSchema,
    }),
});

export { servicesProviderProcessingFeesDataSchema };
//# sourceMappingURL=ServicesProviderProcessingFeesData.js.map
